import React, {useEffect, useState} from 'react';
import {
    UserAndPermissionDto, UserDto, UserRoleDto,
} from "../../../../../../../../dtos";
import Draggable from "react-draggable";
import {Box, Button, Grid} from "@mui/material";
import {PopupHeader} from "../../../../../../../com/popupHeader/popupHeader";
import {makeStyles} from "@mui/styles";
import {useTypedSelector} from "../../../../../../../../hooks/useTypeSelector";
import {PageSpinner} from "../../../../../../../com/pagesTab/pagesSpinner/spinner";
import validator from "validator";
import {TextareaWithLabel} from "../../../../../../../../com/textareaWithLabel/textareaWithLabel";
import {SelectWithLabel} from "../../../../../../../../com/selectWithLabel/selectWithLabel";
import {USER_ROLES} from "../../../../../../../../globals/Contants";
import {SimpleConfirmPopup} from "../../../../../../../../com/simpleConfirmPopup/SimpleConfirmPopup";


const useStyles = makeStyles(() => ({
    createEditWrapperContainer: {
        position: "absolute",
        zIndex: 1061,
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "#00000080",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    createEditPopup: {
        width: `564px`,
        backgroundColor: `#ffffff`,
        maxHeight: `98vh`,
        display: `flex`,
        flexFlow: `column`,
        "& .MuiInputBase-input": {
            padding: `5px`,
            height: `20px`,
        },
    },
    createEditContentWrapper: {
        padding: "20px",
        rowGap: "20px",
        display: "flex",
        flexFlow: "column",
    },
    createEditFieldsWrapper: {
        display: "flex",
        rowGap: "16px",
        flexFlow: "column",
    },
    saveBtn: {
        "&.MuiButton-root": {
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px",
            /* or 157% */

            textAlign: "center",

            color: "#FFFFFF",
            width: "100%",
            borderRadius: "2px",

            background: "linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)",

            paddingTop: "8px",
            paddingBottom: "8px",
            "&.Mui-disabled": {
                opacity: "0.5",
                color: "#FFFFFF",

            }
        },
    }
}));

interface Props {
    onHide: VoidFunction;
    userAndPermissionData: UserAndPermissionDto;
    onSave: (userAndPermissionData: UserAndPermissionDto) => void;
}

export const UserAndPermissionSettingCreateEditPopup: React.FC<Props> = ({
                                                                      onHide,
                                                                      userAndPermissionData,
                                                                      onSave
                                                                  }) => {

    const classes = useStyles();
    const usersAndPermissionsState = useTypedSelector((state) => state.usersAndPermissions);
    const [state, setState] = useState<UserAndPermissionDto>(userAndPermissionData);
    const [defaultState, setDefaultState] = useState<UserAndPermissionDto>(userAndPermissionData);
    const [role, setRole] = useState<UserRoleDto>({
        value: "1",
        label: "Viewer"
    });
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [isShowConfirmPopup, setIsShowConfirmPopup] = useState<boolean>(false);
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr || "");


    const mainLabelColumnNumber = 8;
    const secondaryLabelColumnNumber = 8;

    useEffect(() => {
        setState({
            ...userAndPermissionData,
            acuRole: userAndPermissionData.acuRole || 1,
            acuFirstName: userAndPermissionData.acuFirstName || "",
            acuLastName: userAndPermissionData.acuLastName || "",
            acuEmailAddress: userAndPermissionData.acuEmailAddress || ""
        });
        setDefaultState({
            ...userAndPermissionData,
            acuRole: userAndPermissionData.acuRole || 1,
            acuFirstName: userAndPermissionData.acuFirstName || "",
            acuLastName: userAndPermissionData.acuLastName || "",
            acuEmailAddress: userAndPermissionData.acuEmailAddress || ""
        })
        let role: UserRoleDto;
        switch (userAndPermissionData.acuRole || 1){
            case 3: {
                role = {
                    value: "3",
                    label: "Admin"
                }
                break;
            }
            case 2: {
                role = {
                    value: "2",
                    label: "Editor"
                };
                break;
            }
            default: {
                role = {
                    value: "1",
                    label: "Viewer"
                };
                break;
            }
        }
        setRole(role);

    }, [userAndPermissionData]);


    useEffect(() => {
        if (usersAndPermissionsState.type === "SAVE_USER_AND_PERMISSIONS_DATA_SUCCESS") {
            onHide();
        }

    }, [usersAndPermissionsState.type]);

    useEffect(() => {
        if(state){
            const isNoChanges = compareCurrentAndDefaultState(defaultState, state);
            if(isNoChanges){
                setIsDisabled(isNoChanges);
            } else {
                const isDisabled = !state.acuFirstName?.trim() || !state.acuLastName?.trim() || !validator.isEmail(state.acuEmailAddress ? state.acuEmailAddress.trim() : "")
                setIsDisabled(isDisabled);
            }
        }
    }, [state]);



    const onChangeInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const {value,name} = e.target;
        setState({
            ...state,
            [name]: value.trim()
        });
    }

    const onChangeRole = (item: any) => {
        setState({
            ...state,
            acuRole: Number(item.value)
        })
        setRole(item);
    };

    const onClosePopup = () => {
        const isNoChanges = compareCurrentAndDefaultState(defaultState, state);
        if(isNoChanges){
            onHide();
        } else {
            setIsShowConfirmPopup(true);
        }
    }

    const compareCurrentAndDefaultState = (defaultState: UserAndPermissionDto, currentState: UserAndPermissionDto): boolean => {
        return JSON.stringify(defaultState) === JSON.stringify(currentState);
    }

    const closeConfirmPopup = (): void => {
        setIsShowConfirmPopup(false);
    }

    const onCloseWithoutSaving = (): void => {
        setIsShowConfirmPopup(false);
        onHide();
    }


    const handleSave = () => {
        onSave(state);
    }

    return (
        <Box
            className={classes.createEditWrapperContainer}
        >
            <Draggable
                bounds="body"
                handle={`.draggable_header_store_edit_create_settings_popup`}
                defaultPosition={{x: 0, y: 0}}
            >
                <Box className={`${classes.createEditPopup} store_setting`}>
                    {usersAndPermissionsState.loading &&
                        <Box
                            sx={{
                                position: "absolute",
                                zIndex: "2",
                                height: "100%",
                                width: "100%",
                                backgroundColor: "#e4e4e4a1",
                                display: `flex`,
                                alignItems: `center`,
                                justifyContent: `center`,
                            }}
                        >
                            <PageSpinner/>
                        </Box>
                    }

                    <PopupHeader
                        headerCaption={userAndPermissionData.acuRecId ? "Edit User" : "Create User"}
                        onClose={onClosePopup}
                        bg={"linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)"}
                        jc={"flex-start"}
                        classForHeader={"draggable_header_store_edit_create_settings_popup"}
                    />
                    <Box className={classes.createEditContentWrapper}>
                        <Box className={classes.createEditFieldsWrapper}>
                            <Grid container alignItems={`center`}
                                  columns={36}>
                                <TextareaWithLabel
                                    labelGridSizeNumber={mainLabelColumnNumber}
                                    valueForInput={state.acuFirstName || ""}
                                    labelCaption={'First Name:'}
                                    isBold={true}
                                    maxLength={100}
                                    onChangeInput={onChangeInput}
                                    isNotValid={!state.acuFirstName}
                                    isRequired={true}
                                    fieldName={'acuFirstName'}
                                    labelAlign={"start"}
                                />
                            </Grid>
                            <Grid container alignItems={`center`}
                                  columns={36}>
                                <TextareaWithLabel
                                    labelGridSizeNumber={mainLabelColumnNumber}
                                    valueForInput={state.acuLastName || ""}
                                    labelCaption={'Last Name:'}
                                    isBold={true}
                                    maxLength={100}
                                    onChangeInput={onChangeInput}
                                    isNotValid={!state.acuLastName}
                                    isRequired={true}
                                    labelAlign={"start"}
                                    fieldName={'acuLastName'}
                                />
                            </Grid>
                            <Grid container alignItems={`center`}
                                  columns={36}>
                                <SelectWithLabel
                                    labelGridSizeNumber={mainLabelColumnNumber}
                                    valueForSelect={role}
                                    onChangeSelect={onChangeRole}
                                    selectArray={USER_ROLES}
                                    labelCaption={'Role:'}
                                    labelAlign={`start`}
                                    isBold={true}
                                    isRequired={true}
                                    readonly={userAndPermissionData && Boolean(userAndPermissionData.acuRecId) && userDto && (userDto.emailAddress === userAndPermissionData.acuEmailAddress)}
                                />
                            </Grid>

                            <Grid container alignItems={`center`}
                                  columns={36}>
                                <TextareaWithLabel
                                    labelGridSizeNumber={mainLabelColumnNumber}
                                    valueForInput={state.acuEmailAddress || ""}
                                    labelCaption={'Email:'}
                                    isBold={true}
                                    maxLength={100}
                                    onChangeInput={onChangeInput}
                                    isNotValid={!validator.isEmail(state.acuEmailAddress ? state.acuEmailAddress.trim() : "")}
                                    isRequired={true}
                                    fieldName={'acuEmailAddress'}
                                    labelAlign={"start"}
                                    readonly={!!userAndPermissionData.acuRecId}
                                />
                            </Grid>
                        </Box>
                        <Box>
                            <Grid container columns={36}>
                                <Grid item xs={mainLabelColumnNumber + secondaryLabelColumnNumber}>

                                </Grid>
                                <Grid item xs>
                                    <Button className={classes.saveBtn} onClick={handleSave} disabled={isDisabled}>Save</Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    {/*<StoreSettingPopupContent/>*/}
                </Box>
            </Draggable>
            {isShowConfirmPopup && (
                <SimpleConfirmPopup
                    onClose={closeConfirmPopup}
                    contentText={`Save edits before exit?`}
                    onConfirm={handleSave}
                    buttonText={[`Save`, `Don't Save`, `Cancel`]}
                    onCloseWithoutSaving={onCloseWithoutSaving}
                    isSaveDisabled={isDisabled}
                />
            )}

        </Box>
    )
}